<template>
	<div class="attribute">
		<div class="attribute-body">
			<!-- <div class="fx-title">
				<p>
					副标题
				</p>
			</div>
			<div class="title-box">
				<el-input size='mini' :maxlength='100' @change="subtitleChange" class="title-input" v-model="subtitle" placeholder="限100字符内，支持中英文数字特殊符号"></el-input>
				<el-color-picker @change="subtitlecolourChange" size='mini' :predefine="predefineColors" v-model="subtitlecolour"></el-color-picker>
			</div> -->
			<div class="fx-title">
				<p>
					单位规格
				</p>
			</div>
			<div style="height:40px;float:left;">
				<el-button v-if="flag" size='small' type="primary" style="" plain class='fx-big-btn' :disabled="tableData.length >= 1" @click="addUnit">添加单位</el-button>
				<span style="margin-left: 10px">说明：极速订卖家后台，每个商品只能使用1个单位</span>
			</div>
			<div class="table-box">
				<el-table
				:stripe='true'
				class="grid-content"
				:data="tableData"
				@row-dblclick='rowClick'
				size='mini'
				border>
				<el-table-column
				prop="unitName"
				label="单位"
				align="center"
				min-width="120">
				</el-table-column>
				<el-table-column
				prop="specName"
				label="规格"
				align="center"
				min-width="120">
				</el-table-column>
				<el-table-column
				prop="standardWeight"
				label="标准重量"
				align="center"
				min-width="120">
				</el-table-column>
				<el-table-column
				prop="defaultPrice"
				label="默认价格（元）"
				align="center"
				min-width="150">
				</el-table-column>
				<el-table-column
				prop="customPrice"
				label="自定义单价（元）"
				align="center"
				min-width="150">
				</el-table-column>
				<el-table-column
				prop="defaultUnitflag"
				label="默认单位"
				align="center"
				min-width="150">
				<template slot-scope="scope">
					<span v-if="scope.row.defaultUnitflag === 1">√</span>
				</template>
				</el-table-column>
				<el-table-column
				prop="inventory"
				label="库存"
				align="center"
				min-width="120">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.defaultUnitflag !== 1 &&  flag " type='text' size="mini" icon="el-icon-delete" @click="delItem(scope.row)">删除</el-button>
						<el-button type='text'  v-if="flag"  size="mini" icon="el-icon-edit" @click="editClick(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			</div>
			<div class="fx-title">
				<p>
					商品状态
				</p>
			</div>
			<div class='text-box'>
				<p>可售状态：{{disabledflag}}</p>
				<p>上架状态：
					<el-radio v-model="stackflag" :disabled="!flag" :label="false">上架</el-radio>
					<el-radio v-model="stackflag" :disabled="!flag" :label="true">下架</el-radio>
				</p>
				<div class="fx-title">
					<p>
						属性信息
					</p>
				</div>
				<p>商品产地：{{goodsproductplace}}</p>
				<p>包装清单：{{packlist}}</p>
				<p style="margin-left:13px">保质期：{{qualitydate}}</p>
				<p>厂商名称：{{vendername}}</p>
				<p>贮存条件：{{storage}}</p>
			</div>
			<el-dialog top='60px' :append-to-body='true' class="dialog-title" title="添加单位" :before-close="cancelModal" :visible.sync="addUnitModal" width='800px' :close-on-click-modal="false">
				<addUnitModal :isAdd='addUnitModal' :goodsId='goodsId' :productId='productId' @cancel='cancelAdd' @cancel1='cancelAdd1'></addUnitModal>
			</el-dialog>
			<el-dialog top='60px' :append-to-body='true' title="编辑" :before-close="cancelEdit" :visible.sync="editModal" width='650px' :close-on-click-modal="false">
				<editModal :isAdd='editModal' :productId='productId' :shopid='shopid' :editData='editData'
				@cancel='cancelEdit' :productname='productname'  @cancel1='cancelEdit'></editModal>
			</el-dialog>
		</div>
		<div class="btn-box" v-if="flag">
			<el-button class="btn" plain type="primary" size='small' @click="cancel">取消</el-button>
			<el-button class="btn" plain type="primary" style="margin-left:40px" size='small' @click="save">保 存</el-button>
		</div>
	</div>
</template>

<script>
import addUnitModal from '@/components/storeSetting/saleableGoods/infoModal/addUnitModal.vue'
import editModal from '@/components/storeSetting/saleableGoods/infoModal/editModal.vue'

export default {
	name: 'attribute',
	components: {
		addUnitModal, editModal
	},
	props: {
		productId: String,
		goodsId: String
	},
	data () {
		return {
			predefineColors: [
				'#333333', '#4a4a4a', '#ffffff', '#d0021b', '#f5a623', '#f8e71c', '#8b572a', '#7ed321', '#417505', '#bd10e0', '#9013fe', '#4a90e2', '#50e3c2', '#b8e986', '#000000'
			],
			subtitlecolour: '#333333',
			subtitle: '',
			AuthorityList: {
				'01_0004_0001': false,
				'01_0004_0002': false,
				'01_0004_0003': false,
				'01_0004_0004': false,
				'01_0004_0005': false,
				'01_0004_0006': false,
				'01_0004_0007': false,
				'01_0004_0008': false
			},
			productname: '',
			addUnitModal: false,
			flag: false,
			editData: {},
			editModal: false,
			tableData: [{ unit: '克' }],
			goodsproductplace: '',
			qualitydate: '',
			vendername: '',
			packlist: '',
			storage: '',
			disabledflag: '',
			stackflag: '',
			status: '可售',
			isSeal: '1',
			shopid: ''
		}
	},
	watch: {
		productId: {
			handler (val) {
				this.init()
				this.getAuthority('01_0001_0000_00')
			},
			immediate: true
		}

	},
	created () {
		console.log(this.productId)
	},
	methods: {
		subtitlecolourChange () {
			if (this.subtitlecolour === null) {
				this.subtitlecolour = '#000000'
			}
		},
		subtitleChange () {
			if (this.subtitle.match(/^[ ]*$/)) {
				this.subtitle = ''
			}
			this.subtitle = this.subtitle.replace(/[',\\]/g, '')
		},
		rowClick (row, column, event) {
			this.editClick(row)
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let b = window.sessionStorage.getItem('isAdd')
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					if (b) {
						if (this.AuthorityList['01_0001_0002_00']) {
							this.flag = true
						} else {
							this.flag = false
						}
					} else {
						if (this.AuthorityList['01_0001_0001_00']) {
							this.flag = true
						} else {
							this.flag = false
						}
					}
				}
			})
		},
		init () {
			let params = {
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productAttrInfo/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.productname = res.data.productname
					this.tableData = res.data.goodsUnit
					this.goodsproductplace = res.data.goodsproductplace
					this.packlist = res.data.packlist
					this.qualitydate = res.data.qualitydate
					this.vendername = res.data.vendername
					this.storage = res.data.storage
					this.subtitlecolour = res.data.subtitlecolour
					this.subtitle = res.data.subtitle
					this.shopid = res.data.shopid
					if (res.data.salestate === 0) {
						this.disabledflag = '不可售'
					} else {
						this.disabledflag = '可售'
					}
					this.stackflag = res.data.stackflag
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel1 () {
			this.editModal = false
		},
		cancelEdit () {
			this.editModal = false
			this.init()
		},
		editClick (data) {
			this.editModal = true
			this.editData = data
		},
		save () {
			let params = {
				subtitlecolour: this.subtitlecolour,
				subtitle: this.subtitle,
				id: this.productId,
				stackflag: this.stackflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productAttrInfo/update`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.init()
					this.$message.success('保存成功')
					// this.$emit('cancel')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		delItem (data) {
			let params = {
				id: data.pavid,
				attrplanid: data.papid,
				goodsunitid: data.goodsunitid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productUnit/remove`,
				data: params
			}).then(res => {
				console.log(res)
				if (res.result === true) {
					this.init()
					this.$message.success('删除成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelAdd1 (data) {
			this.addUnitModal = data
		},
		cancelAdd (data) {
			this.addUnitModal = data
			this.init()
		},
		addUnit () {
			this.addUnitModal = true
		},
		cancelModal () {
			this.addUnitModal = false
		},
		cancel () {
			this.$emit('cancel')
		}
	}
}
</script>
<style lang="stylus" scoped>
.attribute{
    display:flex;
	width:100%;
	flex-direction :column;
	.attribute-body{
		flex:1;
		width:100%;
		overflow-y :auto;
	}
    .btn{
        width :200px;
    }
    .btn-box{
		height:50px;
        text-align :center
    }
    .table-box{
        margin-top:10px
    }
	.title-box{
		width:100%;
		display:flex;
		flex-direction :row
		.title-input{
			width :400px;
			margin-right:10px
		}
	}
    .text-box{
        text-align :left
        font-size :13px
        .el-radio__label{
            font-size :13px
        }
        p{
            margin:10px 0px
        }
    }
}
</style>
<style lang="stylus">
.attribute {
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
}
</style>
